export default "__VITE_ASSET__14862805__"